/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.plastron.ts
 *
 * Messages de la BORNE TACTILE (/borne, « mode plastron » du jour J) : grand
 * écran tactile en libre accès, sans badge ni connexion, sans aucune donnée
 * personnelle. Retour automatique à l'accueil après inactivité.
 *
 * Vocabulaire piloté par l'événement : jetons {eventXxx} et {lexXxx}, jamais
 * « salon », « atelier », « exposant » ni nom d'événement en dur.
 * Apostrophe typographique (’) partout ; aucun tiret cadratin.
 * Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesPlastronFr: Record<string, string> = {
  'acces.titre.borne': 'Borne d’information',

  // ── Navigation ─────────────────────────────────────────────────────────
  'borne.nav.label': 'Rubriques',
  'borne.nav.accueil': 'Accueil',
  'borne.nav.offres': 'Offres',
  'borne.nav.exposants': '{lexExhibitorPluralCap}',
  'borne.nav.programme': 'Programme',
  'borne.nav.plan': 'Plan',
  'borne.nav.inscription': 'S’inscrire',

  // ── Accueil ────────────────────────────────────────────────────────────
  'borne.accueil.invite': 'Touchez une rubrique pour commencer',
  'borne.tuile.offres': '{n, plural, =0 {Les offres} one {# offre} other {# offres}}',
  'borne.tuile.offresSous': 'Cherchez un métier, un contrat, une ville',
  'borne.tuile.exposants':
    '{n, plural, =0 {{lexExhibitorPluralCap}} one {# {lexExhibitorBare}} other {# {lexExhibitorPlural}}}',
  'borne.tuile.exposantsSous': 'Qui recrute, et quels postes',
  'borne.tuile.programme': 'Programme',
  'borne.tuile.programmeSous': '{lexWorkshopPluralCap} et horaires',
  'borne.tuile.plan': 'Plan',
  'borne.tuile.planSous': 'Pour vous repérer',
  'borne.tuile.inscription': 'S’inscrire',
  'borne.tuile.inscriptionSous': 'Sur votre téléphone, en un instant',

  // ── Recherche et filtres ───────────────────────────────────────────────
  'borne.recherche.offres': 'Rechercher un métier, une ville',
  'borne.recherche.exposants': 'Rechercher par nom, ville, secteur',
  'borne.recherche.effacer': 'Effacer la recherche',
  'borne.filtre.label': 'Type de contrat',
  'borne.filtre.tous': 'Tous',
  'borne.resultats': '{n, plural, =0 {Aucun résultat} one {# résultat} other {# résultats}}',

  // ── Fiches ─────────────────────────────────────────────────────────────
  'borne.offre.postes': '{n, plural, one {# poste} other {# postes}}',
  'borne.offre.contrat': 'Contrat',
  'borne.offre.niveau': 'Expérience',
  'borne.offre.lieu': 'Lieu',
  'borne.offre.secteur': 'Secteur',
  'borne.exposant.offres': '{n, plural, =0 {Aucune offre publiée} one {# offre} other {# offres}}',
  'borne.exposant.voirOffres': 'Voir ses offres',
  'borne.fiche.fermer': 'Fermer',
  'borne.fiche.postuler': 'Pour postuler : scannez, puis inscrivez-vous sur votre téléphone',
  'borne.fiche.reserver': 'Pour réserver une place : scannez avec votre téléphone',
  'borne.fiche.suivre': 'Retrouvez cette fiche sur votre téléphone',

  // ── Programme ──────────────────────────────────────────────────────────
  'borne.programme.enCours': 'En cours',
  'borne.programme.aVenir': 'À venir',
  'borne.programme.termine': 'Terminé',
  'borne.programme.complet': 'Complet',
  'borne.programme.places': '{n, plural, one {# place} other {# places}}',
  'borne.programme.vide': 'Le programme sera bientôt en ligne.',

  // ── Plan, inscription ──────────────────────────────────────────────────
  'borne.plan.vide': 'Le plan sera bientôt disponible.',
  'borne.inscription.titre': 'Inscrivez-vous, déposez votre CV',
  'borne.inscription.texte':
    'Scannez ce code avec l’appareil photo de votre téléphone. Rien n’est saisi sur cet écran.',

  // ── États ──────────────────────────────────────────────────────────────
  'borne.etat.chargement': 'Chargement…',
  'borne.etat.bientot': 'Les listes ouvrent très bientôt au public.',
  'borne.etat.connexion': 'Cette borne doit être reliée par l’organisation.',
  'borne.etat.indisponible': 'Informations momentanément indisponibles.',
  'borne.etat.reessayer': 'Réessayer',
  'borne.horsLigne': 'Hors ligne : informations de {heure}',

  // ── Sortie protégée (organisation uniquement) ──────────────────────────
  'borne.sortie.titre': 'Réservé à l’organisation',
  'borne.sortie.texte': 'Que voulez-vous faire ?',
  'borne.sortie.recharger': 'Recharger la borne',
  'borne.sortie.relier': 'Relier la borne (compte de démonstration)',
  'borne.sortie.quitter': 'Quitter la borne',
  'borne.sortie.annuler': 'Revenir à la borne',
  'borne.retourAccueil': 'Retour à l’accueil',
};
